export default function EquipmentInfrastructure() {
  const data = [
    { type: "Material Hoist Machines", quantity: 2 },
    { type: "Manual Concrete Mixers", quantity: 2 },
    { type: "Electric Vibrators", quantity: 20 },
    { type: "Dewatering Pumps", quantity: 5 },
    { type: "Curing Pumps", quantity: 3 },
    { type: "Welding Machines", quantity: 2 },
    { type: "Cutting & Grinding Machines", quantity: 6 },
    { type: "TMT Steel Cutting Machines", quantity: 3 },
    { type: "TMT Steel Bending Machines", quantity: 3 },
    { type: "Concrete Breaker Machines", quantity: 6 },
    { type: "Hiti Drilling Machine", quantity: 6 },
    { type: "TMT Steel Cutting Machines", quantity: 3 },
    { type: "TMT Steel Bending Machines", quantity: 3 },
    { type: "Concrete Breaker Machines", quantity: 6 },
    { type: "Hilti Drilling Machines", quantity: 3 },
    { type: "Concrete Plant (18m³/hour)", quantity: 1 },
    { type: "Potain Tower Cranes (50m boom)", quantity: 3 },
    { type: "Concrete Casting Pump", quantity: 1 },
    { type: "Supporting Electrical Machinery", quantity: "All required" },
  ];

  return (
    <section className="bg-white py-20 px-4 md:px-10 equ-bg-img">
      <div className="text-center mb-12 equ-title">
        <h2 data-aos="fade-up" className="text-4xl font-bold text-black mb-2">
          Equipment & Infrastructure
        </h2>
        <p data-aos-delay="450" data-aos="fade-up" className="text-gray-600 text-sm">
          We maintain our own fleet of machinery and tools, enabling us to
          execute projects without third-party delays:
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <h3 data-aos="fade-up" data-aos-delay="750" className="equ-subtitle">
          Construction Machinery Inventory
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-center">
            <thead>
              <tr className="bg-white text-black border-b">
                <th className="th-title">Machine Type</th>
                <th className="th-title">Quantity</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? "bg-[#EDF3FF]" : ""}>
                  <td className="py-4 px-4 td-width">{item.type}</td>
                  <td className="py-4 px-4 td-width">{item.quantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="bottom-para">
            This team is supplemented with a network of trusted subcontractors,
            vendors, and on-call specialists for services like MEP,
            waterproofing, façade engineering, and interior design.
          </p>
        </div>
      </div>
    </section>
  );
}
